// extracted by mini-css-extract-plugin
export default {"termsConditionPage":"style_termsConditionPage__TikQG","pageTitle":"style_pageTitle__cg5qj","personalInfo":"style_personalInfo__hR6-e","infoList":"style_infoList__6RaCP"};